import {
  Button,
  Modal,
  ModalClose,
  ModalContent,
  ModalHead,
} from "@songtradr-one/components-frontend";
import { ModalFoot, ModalWrapper, Props, text } from "./ModalConfirm.Parts";

export const ModalConfirm = ({
  open,
  title,
  loading,
  className,
  description,
  cancelLabel,
  confirmLabel,
  onConfirm,
  onOpenChange,
  onCancel,
  preventDismiss,
  confirmVariant = "primary",
  children,
}: Props) => (
  <Modal open={open} onOpenChange={onOpenChange}>
    <ModalWrapper
      className={className}
      onOpenAutoFocus={(e) => e.preventDefault()}
      {...(preventDismiss && {
        onInteractOutside: (e) => e.preventDefault(),
        onEscapeKeyDown: (e) => e.preventDefault(),
      })}
      preventDismiss={preventDismiss}
    >
      {!preventDismiss && <ModalClose />}
      <ModalHead title={title} description={description} />
      {children && <ModalContent>{children}</ModalContent>}
      <ModalFoot>
        {!preventDismiss && (
          <Button
            $variant="subtle"
            onClick={() => (onCancel ? onCancel() : onOpenChange(false))}
          >
            {cancelLabel || text.shared.cancel}
          </Button>
        )}
        <Button $variant={confirmVariant} onClick={onConfirm} loading={loading}>
          {confirmLabel}
        </Button>
      </ModalFoot>
    </ModalWrapper>
  </Modal>
);
